export default "__VITE_ASSET__DI5d7Ry6__"